module.exports = __webpack_public_path__ + "img/areaBackground.a5791392.png";